{
  "browserNotSupported": {
    "title": "Modul se nepodařilo načíst",
    "text": "K používání prohlížeče dílů prosím přejděte na některý z aktuálních prohlížečů"
  },
  "main": {
    "more": "Další příslušenství",
    "findMore": "Příslušenství pro dovybavení/přestavbu a modernizaci vašeho vozidla najdete zde v naší rozsáhlé nabídce. Vámi vybrané příslušenství bude zasláno vašemu {{brand}} partnerovi spolu s požadavkem na vozidlo.",
    "topOffers": "TOP nabídky",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produkty",
    "noArticleFound": "0 Produkty",
    "oemHint": "Vyberte si příslušenství pro váš vůz {{brand}}!",
    "noBrand": "Vyberte si příslušenství pro své vozidlo!",
    "outOfOrder": "V současné době bohužel nejsou k dispozici žádné produkty.<0/>V současné době aktualizujeme náš katalog.<0/>Navštivte nás prosím znovu později.",
    "nextSlide": "Další",
    "prevSlide": "Předchozí"
  },
  "cart": {
    "add": "Produkt přidán do vozidla",
    "fullPrice": "Cena vozidla a příslušenství",
    "priceWithoutCar": "Cena příslušenství"
  },
  "navigation": {
    "zoom": "Přiblížit",
    "toggleSearch": "Přepnout vyhledávání",
    "cart": "Košík",
    "cartDelete": "Odstranit položku z košíku",
    "vehicle": "Vybrané vozidlo",
    "maxBookmarksReached": "",
    "filter": {
      "toggleFilter": "Přepnout filtr",
      "topProducts": "Nejprodávanější",
      "reset": "Resetovat filtr",
      "ready": "Hotovo",
      "show": "Zobrazit výsledky"
    },
    "searching": {
      "submit": "Hledat",
      "close": "Zavřít",
      "placeholder": "Najít odpovídající příslušenství ...",
      "suggestions": "Návrhy vyhledávání",
      "categories": "Kategorie",
      "products": "Produkty",
      "productCount": "{{count}} produkt",
      "productCount_one": "{{count}} produkt",
      "productCount_few": "{{count}} produkty",
      "productCount_other": "{{count}} produktů",
      "showAll": "Zobrazit {{count}} výsledek",
      "showAll_one": "Zobrazit {{count}} výsledek",
      "showAll_few": "Zobrazit všechny {{count}} výsledky",
      "showAll_other": "Zobrazit všech {{count}} výsledků",
      "expand": "Rozšířené vyhledávání",
      "show": "Zobrazit výsledky",
      "found": {
        "withCategory": "Výsledky hledání pro \"{{fuzzy}}\" v kategorii \"{{category}}\"",
        "withOutCategory": "Výsledky hledání pro \"{{fuzzy}}\" ze všech kategorií"
      }
    },
    "share": "Share",
    "back": "Zpět",
    "details": "Detaily",
    "add": "Přidat",
    "remove": "Odstranit",
    "close": "Zavřít",
    "filtern": "Filtr",
    "closeFilter": "Zavřít filtr"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Skok na obrázek {{number}}"
    },
    "articleNumber": "Produktové číslo",
    "relatedArticle": "Tento produkt by vás mohl také zajímat:",
    "brand": "Značka",
    "priceBox": {
      "withVatAndMounting": "vč. DPH & montáže",
      "withVat": "vč. DPH",
      "recommendedRetailPrice": "Standardní cena",
      "historicMinimalPurchasePrice": "Nejnižší cena za posledních 30 dní",
      "priceDetails": "Podrobnosti o ceně",
      "priceDetailsHeadline": "Podrobnosti o ceně této položky",
      "priceToday": "Dnešní cena této položky",
      "priceDetails30Days": "Nejnižší cena v 30 dnech před změnou ceny",
      "close": "Zavřít",
      "addItem": "přidat produkt",
      "removeItem": "odstranit produkt"
    },
    "infoBox": {
      "description": "Popis",
      "vehicles": "Vhodné pro následující modely",
      "empty": "Pro tento výrobek neexistují žádná zvláštní přiřazení k vozidlům.",
      "contacts": "Výrobce"
    },
    "contacts": {
      "manufacturer-contact": "Kontaktní informace výrobce",
      "responsible-contact": "Odpovědná osoba v EU",
      "trademark": "Značka"
    }
  },
  "productList": {
    "oemHint": "Originální příslušenství pro vaši {{brand}}"
  }
}
